import { Http, Response, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';


@Injectable()
export class DocumentService {
  // private http: Http, 
  constructor(private authHttp: AuthHttp) { }

  addNewDocument(document: any){
    return this.authHttp.post("/api/document/", document).map(res => res.json());
  }

  updateDocument(document: any){
    return this.authHttp.put("/api/document/", document).map(res => res.json());
  }

  getAllDocuments(){
    return this.authHttp.get("/api/document/").map(res => res.json());
  }

  getMyDocuments(id:number){
    return this.authHttp.get("/api/document/"+id).map(res => res.json());
  }

  deleteDocument(id:number){
    return this.authHttp.delete("/api/document/"+id).map(res => res.json());
  }

  downloadDocument(id: number) {
    return this.authHttp.get(`/api/document/downloadDocument/${id}`, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/document.service.ts